import React, { Component } from 'react';
import { Redirect }         from "react-router-dom";
import Navbar               from './Navbar';
import FileDropzone         from './FileDropzone';
import File                 from './File';
import API                  from './server_api'
import FolderStats          from './FolderStats';
import Breadcrumbs          from './Breadcrumbs';
import { isAuthenticated }  from './Login'



export default class Folder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name:            null,
            id:              this.props.match.params.id,
            zip_token:       null,
            parent_id:       null,
            files:           [],
            uploading_now:   false,
            upload_started:  null,
            uploaded_so_far: 0,
            total_to_upload: 0,
            total_uploaded:  0,
         };

        this.onFilesAdded     = this.onFilesAdded.bind(this);
        this.onCancelFile     = this.onCancelFile.bind(this);
        this.onFileUpoaded    = this.onFileUpoaded.bind(this);
        this.onUploadProgress = this.onUploadProgress.bind(this);
        this.onUploadError    = this.onUploadError.bind(this);
        this.onFileListLoaded = this.onFileListLoaded.bind(this);
    }

    componentWillMount() {
        if ( isAuthenticated() )
            API.getFolder( this.onFileListLoaded, this.props.match.params.id );
    }

    onFileListLoaded(json){
        let size=0;
        for (let i in json.files)
            size += json.files[i].size;
        this.setState({
            name:        json.name,
            parent_id:   json.parent_id,
            parent_name: json.parent_name,
            files:       json.files,
            zip_token:   json.zip_token,
            total_uploaded: size,
        });
    }

    onFilesAdded(files){
        const new_files=[];
        let added_size=0;
        // Добавляем новые файлы в очередь на закачку
        for (let i in files) {
            // не позволяем заливать дубликаты
            let duplicate = false;
            for (let j in this.state.files){
                if ( this.state.files[j].error !== true &&  this.state.files[j].name === files[i].name ) {
                    duplicate = true;
                    new_files.push({ name: files[i].name, error: true, error_text: "Файл с таким именем уже есть в этой папке." });
                    break;
                }
            }
            // ставим в очередь на закачку
            if ( duplicate === false ){
                const file = { 
                    name: files[i].name,
                    size: files[i].size,
                    file: files[i],
                    queued: true, 
                };
                new_files.push(file);
                added_size += files[i].size;
            }
        }
        // асинхронно добавляем их к состоянию
        this.setState( old_state => ({
            files: old_state.files.concat(new_files),
            total_to_upload: old_state.total_to_upload+added_size,
        }));
        // запускаем закачку следующих по очереди
        this.rollQueue();
    }

    rollQueue(){
        // делаем обновление асинхронно
        if ( isAuthenticated() ) // нужно регулярно вызывать этот метод, чтобы обнолять устаревающие токены
            this.setState( old_state => {

            const files = old_state.files;
            // считаем количество текущих закачек
            let uploads = 0;
            for (let i in files)
                if ( files[i].uploading )
                    uploads++;

            // запускаем новые, если нужно
            while (uploads < 3){
                // ищем следующую в очереди
                let next = null;
                for(let i in files){
                    if ( files[i].queued ){
                        next = i;
                        break;
                    }
                }

                // выходим, если очередь закончилась
                if (next === null)
                    break;

                // запускаем реальную загрузку
                const ref = API.uploadFile(this.props.match.params.id, files[next].file, this.onUploadProgress, this.onFileUpoaded, this.onUploadError);

                // добавляем в табличку новую загрузку
                files[next] = { 
                    name: files[next].name,
                    size: files[next].size,
                    uploading: true, 
                    progress: 0,
                    ref,
                };
                uploads++;
            }
            
            // если это самое начало - инициализируем статистику
            if ( (!old_state.uploading_now) && uploads > 0 ){
                // считаем полный объем данных для закачки
                let to_upload = 0;
                for (let i in files)
                    if ( files[i].uploading || files[i].queued )
                        to_upload += files[i].size;

                // обвноляем состояние и статистику
                return { 
                    files: files,
                    uploading_now: true,
                    upload_started: new Date(),
                    total_to_upload: to_upload,
                    uploaded_so_far: 0
                };
            }

            // просто обновляем состояние
            return { 
                files: files,
                uploading_now: (uploads > 0),
            };
        });
    }

    onCancelFile(event){
        event.preventDefault();
        const index = event.target.id;
        // обрываем закачку
        if ( this.state.files[index].uploading )
            this.state.files[index].ref.abort();
        // асинхронно удаляем из состояния
        this.setState( old_state =>{
            const new_files = old_state.files;
            const size = new_files[index].size;
            new_files.splice(index, 1);
            return { 
                files: new_files,
                total_to_upload: old_state.total_to_upload - size,
            };
        });
        // запускаем закачку следующих по очереди
        this.rollQueue();
    }

    // Обновляем состояние при окончании загрузки файла
    onFileUpoaded(name, json){
        this.setState( old_state => {
            const copy = old_state.files;
            let size=0;
            for (let i in copy){
                const file =  copy[i];
                if ( file.uploading && file.name === name ){
                    if ( json.error !== undefined ){
                        copy[i] = { name, error: true, error_text: json.error };
                    }
                    else {
                        copy[i] = json; 
                    }
                    size += file.size;
                    break;
                }
            }
            return ({ 
                files:           copy,
                uploaded_so_far: old_state.uploaded_so_far+size,
                total_uploaded:  old_state.total_uploaded+size,
            });
        });
        // запускаем закачку следующих по очереди
        this.rollQueue();
    }

    // Обновляем прогресс загрузки файла
    onUploadProgress(name, progress){
        this.setState( old_state => {
            const copy = old_state.files;
            for (let i in copy){
                const file =  copy[i];
                if ( file.uploading && file.name === name )
                    copy[i].progress = progress;
            }
            return ( { files: copy });
        });
    }

    // Ошибка загрузки,обновляем статус
    onUploadError(name, text){
        this.setState( old_state => {
            const copy = old_state.files;
            for (let i in copy){
                const file =  copy[i];
                if ( file.uploading && file.name === name )
                    copy[i] =  { name, error: true, error_text: text }
            }
            return ( { files: copy });
        });
    }

    render () {
        // неавторизованных пользователей перенаправляем на страницу логина
        if ( !isAuthenticated() )
            return (<Redirect to={{ pathname: "/login", state: { from: this.props.location }}} />);

        // указатели на ссылки для скачивания
        let linkrefs=[];
        let saveRef = function (ref) { linkrefs.push(ref); }

        // готовим массив файлов - оснащаем коллбеками
        const files = [];
        for(let i in this.state.files ){
            let file = this.state.files[i];
            file.index = i;
            file.callback = this.onCancelFile;
            file.saveRef = saveRef;
            files.push(File(file));
        }

        return ([
            <Navbar key='navbar' />,
            <Breadcrumbs key='breadcrumbs' 
                parent_id = {this.state.parent_id}
                parent_name = {this.state.parent_name}
                name = {this.state.name}/>,
            <main key='body' role="main" className="container">
                <FolderStats stats={this.state} linkrefs={linkrefs} />
                <FileDropzone onFilesAdded={this.onFilesAdded}>
                    <div className="list-group shadow">
                        {files}
                    </div>
                </FileDropzone>
            </main>
        ]);
    }
}
